import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SvgIconModule } from '@customcomponent/Icons/_svg/app-jt-svg-icon.module';
import { CustomTranslateLoader } from "../../../../_services/custom.loader";
import { ItrentintegrationCompenent } from "./itrent-integration.component";
import { FileProgressComponent } from "./file-progress/itrent-file-progress.component";



@NgModule({
  declarations: [
    ItrentintegrationCompenent,
    FileProgressComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot(),
    SvgIconModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [ItrentintegrationCompenent]
})
export class ItrentintegrationModule { }
